import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';
import { isAttachmentFeatureEnabled } from 'owa-attachment-feature-flags';
import { getBposNavBarData } from 'owa-bpos-store';
import { trace } from 'owa-trace';
var SHAREPOINT_BASE_URL = 'https://microsoft.sharepoint.com';
export default function isSharePointLink(linkUrl) {
    var bposNavBarData = getBposNavBarData();
    if (!bposNavBarData) {
        trace.info('isSharePointLink:bposNavBarData is null');
        return false;
    }
    if (isSharePointLinkPrefixedWithBaseUrl(linkUrl, bposNavBarData.SPO_MySiteHostUrl)) {
        logUsage(datapoints.AttachmentComposeSPMySiteLinks.datapoint.name);
        return true;
    }
    if (isSharePointLinkPrefixedWithBaseUrl(linkUrl, bposNavBarData.SPO_RootSiteUrl)) {
        return true;
    }
    if (isAttachmentFeatureEnabled('doc-SharePoint-dogfoodUser')) {
        return isSharePointLinkPrefixedWithBaseUrl(linkUrl, SHAREPOINT_BASE_URL);
    }
    return false;
}
function isSharePointLinkPrefixedWithBaseUrl(linkUrl, baseUrl) {
    if (linkUrl.indexOf(baseUrl) === 0) {
        return linkUrl !== baseUrl;
    }
    return false;
}
//# sourceMappingURL=isSharePointLink.js.map